export default {
  LIST(state, data) {
    state.categorySubjects = data
  },
  UPDATE_CATEGORY_SUBJECT(state, value) {
    state.categorySubject = {
      ...value,
      science_sector_code: value.science_sector_code ?? null,
    }
  },
  FRESH_CATEGORY_SUBJECT(state) {
    state.categorySubject = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
      science_sector_code: null,
    }
  },
}
